module.exports = __webpack_public_path__ + "img/right.17546971.png";